import { debounce } from 'lodash';

export default class BrixTabMenu {
  static init(...parameters) {
    return new BrixTabMenu(...parameters);
  }

  constructor(block) {
    this.tabMenuWrapper = block.querySelector('.tab-menu-wrapper');
    this.tabMenu = block.querySelector('.tab-menu');
    this.tabMenu.addEventListener('scroll', debounce(() => { this.toggleFadeVisibility(); }, 10));
    window.addEventListener('resize', debounce(() => { this.toggleFadeVisibility(); }), 300);
    this.toggleFadeVisibility();

    if (!block.classList.contains('-no-reload')) {
      return;
    }

    this.menuItems = block.querySelectorAll('.menu-item');
    this.tabs = block.querySelectorAll('.tab');

    [...this.menuItems].forEach((item) => {
      item.addEventListener('click', event => this.handleMenuClick(event));

      if (window.location.hash === `#${item.dataset.hash}`) {
        const scrollToElement = block.querySelector(`.${block.id}-anchor-${item.dataset.hash}`);
        if (scrollToElement) {
          setTimeout(() => {
            scrollToElement.scrollIntoView();
          }, 200);
        }

        this.setCurrent(item.dataset);
      }
    });

    window.addEventListener('hashchange', () => {
      [...this.menuItems].forEach((item) => {
        if (window.location.hash === `#${item.dataset.hash}`) {
          this.setCurrent(item.dataset);
        }
      });
    });
  }

  handleMenuClick(event) {
    this.setCurrent(event.target.dataset);
  }

  setCurrent(dataset) {
    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }

    [...this.menuItems].forEach((item) => {
      if (item.dataset.id === dataset.id) {
        item.classList.add('-current');
      } else {
        item.classList.remove('-current');
      }
    });
    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }

  toggleFadeVisibility() {
    const wrapperClassList = this.tabMenuWrapper.classList;

    // Show left fade
    if (this.tabMenu.scrollLeft > 1 && !wrapperClassList.contains('-left-fade')) {
      wrapperClassList.add('-left-fade');
    }

    // Hide left fade
    if (this.tabMenu.scrollLeft < 1 && wrapperClassList.contains('-left-fade')) {
      wrapperClassList.remove('-left-fade');
    }

    // Show right scroll button
    if (this.tabMenu.scrollLeft > 1 && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Show right scroll button
    if (this.tabMenu.scrollLeft + this.tabMenu.offsetWidth
      <= this.tabMenu.scrollWidth && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Hide right scroll button
    if (this.tabMenu.scrollLeft + this.tabMenu.offsetWidth
      >= this.tabMenu.scrollWidth && wrapperClassList.contains('-right-fade')) {
      wrapperClassList.remove('-right-fade');
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-tab-menu', BrixTabMenu.init);
}
